<ng-template
  #navBtn
  let-action="action"
  let-borderTop="borderTop"
  let-icon="icon"
  let-link="link"
  let-name="name"
  let-submenuUUID="submenuUUID"
  let-svgIcon="svgIcon"
>
  <div
    (click)="action ? action() : noop()"
    [ngClass]="{ 'border-top': borderTop }"
    [routerLink]="link"
    class="nav-btn p-2 noselect"
    routerLinkActive="active"
  >
    <fa-icon
      *ngIf="icon"
      [fixedWidth]="true"
      [icon]="icon"
      class="nav-icon"
    ></fa-icon>
    <svg-icon
      *ngIf="svgIcon"
      name="140a"
      svgClass="icon x1-5 sanakey-color fill"
    ></svg-icon>
    <span class="ms-3">{{ name }}</span>
  </div>
  <ul
    *ngIf="submenuUUID && productsRoutes[submenuUUID]?.length"
    [class.active]="router.isActive(link, false)"
    class="list-unstyled produktUnterMenu"
  >
    <li
      *ngFor="let untermenu of productsRoutes[submenuUUID]"
      [routerLink]="[link].concat(untermenu.url)"
      class="border-left nav-btn p-2 noselect"
      routerLinkActive="active"
    >
      {{ untermenu.label }}
    </li>
  </ul>
</ng-template>

<div
  (click)="active = false"
  [ngClass]="{ active: hover || active }"
  class="backdrop"
></div>
<div
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseExit()"
  [ngClass]="{ active: active }"
  class="sidebar h-100"
>
  <div class="widthPreserver h-100 d-flex flex-column bg-light">
    <ng-container
      *ngTemplateOutlet="
        navBtn;
        context: {
          icon: meinSanakeyPortalIcon,
          name: 'Mein Sanakey-Portal',
          link: '/dashboard',
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        navBtn;
        context: {
          icon: meineStammdaten,
          name: 'Meine Stammdaten',
          link: '/stammdaten',
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        navBtn;
        context: {
          icon: dokumenteVertraegeIcon,
          name: 'Dokumente & Verträge',
          link: '/dokumente-vertraege',
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="navBtn; context:{icon: benachrichtigungenIcon, name:'Benachrichtigungen', link: '/notifications'}"></ng-container>

    <div class="produkt-liste flex-fill">
      <!-- Produkt Liste -->
      <div class="separator text-center small p-2">
        <div class="dummy-icon"></div>
        <span class="ms-3"
        >Produkte<span
        >&nbsp;
            <fa-icon
              *ngIf="productsInfo.state === LoadingState.Loading"
              [icon]="spinnerIcon"
              animation="spin-pulse"
            ></fa-icon></span
        ></span>
      </div>
      <div
        *ngIf="!productsInfo.allRawProducts.length"
        class="text-center small"
      >
        - keine aktiven Produkte -
      </div>

      <ng-container *ngFor="let product of productsInfo.activeProducts">
        <ng-container
          *ngTemplateOutlet="
            navBtn;
            context: {
              icon: productIcon,
              name: product.name,
              link:
                '/' +
                $any(
                  mapping[product.uuid] ? mapping[product.uuid] : product.uuid
                ).url,
              submenuUUID: product.uuid,
            }
          "
        ></ng-container>
      </ng-container>
      <!-- Produkt Liste Ende -->
    </div>

    <div
      class="nav-btn p-2 noselect"
      routerLink="/kontakt-und-hilfe"
      routerLinkActive="active"
    >
      <fa-icon [fixedWidth]="true" [icon]="helpIcon" class="nav-icon"></fa-icon>
      <span class="ms-3">Kontakt & Hilfe</span>
    </div>
    <ul
      [class.active]="router.isActive('/kontakt-und-hilfe', false)"
      class="list-unstyled produktUnterMenu"
    >
      <li
        class="border-left nav-btn p-2 noselect"
        routerLink="/kontakt-und-hilfe/kontakt"
        routerLinkActive="active"
      >
        Kontakt
      </li>
    </ul>

    <div
      (click)="abmeldenClicked()"
      class="nav-btn p-2 noselect"
      routerLink="/abmelden"
      routerLinkActive="active"
    >
      <div [ngClass]="{ 'show-second': abmeldungLaeuft }" class="icons">
        <fa-icon
          [fixedWidth]="true"
          [icon]="abmeldenIcon"
          class="icon-default nav-icon"
        ></fa-icon>
        <fa-icon
          [fixedWidth]="true"
          [icon]="spinnerIcon"
          animation="spin-pulse"
          class="icon-second nav-icon"
        ></fa-icon>
      </div>
      <span class="ms-3">Abmelden</span>
    </div>
  </div>
</div>
